"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyQuestionLayoutType = exports.SurveyQuestionType = exports.FETCH_USER_REPONSE = exports.RESET = exports.SUBMIT_SURVEY = exports.ERROR_RESET = exports.UPDATE_SURVEY_POST_RESPONSE = exports.USER_SURVEY = void 0;
const USER_SURVEY = 'survey/USER_SURVEY';
exports.USER_SURVEY = USER_SURVEY;
const FETCH_USER_REPONSE = 'survey/FETCH_USER_REPONSE';
exports.FETCH_USER_REPONSE = FETCH_USER_REPONSE;
const UPDATE_SURVEY_POST_RESPONSE = 'survey/UPDATE_SURVEY_POST_RESPONSE';
exports.UPDATE_SURVEY_POST_RESPONSE = UPDATE_SURVEY_POST_RESPONSE;
const ERROR_RESET = 'survey/ERROR_RESET';
exports.ERROR_RESET = ERROR_RESET;
const SUBMIT_SURVEY = 'survey/SUBMIT_SURVEY';
exports.SUBMIT_SURVEY = SUBMIT_SURVEY;
const RESET = 'survey/RESET';
exports.RESET = RESET;
var SurveyQuestionType;
(function (SurveyQuestionType) {
    SurveyQuestionType[SurveyQuestionType["Text"] = 1] = "Text";
    SurveyQuestionType[SurveyQuestionType["SingleSelect"] = 2] = "SingleSelect";
    SurveyQuestionType[SurveyQuestionType["MultiSelect"] = 3] = "MultiSelect";
})(SurveyQuestionType || (exports.SurveyQuestionType = SurveyQuestionType = {}));
var SurveyQuestionLayoutType;
(function (SurveyQuestionLayoutType) {
    SurveyQuestionLayoutType["RADIO"] = "RADIO";
    SurveyQuestionLayoutType["SELECT"] = "SELECT";
})(SurveyQuestionLayoutType || (exports.SurveyQuestionLayoutType = SurveyQuestionLayoutType = {}));
//# sourceMappingURL=types.js.map